/**
 * Régua de camadas da navbar global (GEN-3497).
 *
 * O host é Chakra e a lib do Kanban 2.0 é Radix. Popover Radix montado dentro de um
 * container Chakra copia o z-index do CONTEÚDO no mount, então camada implícita já
 * produziu painel escondido atrás de modal. Aqui os valores ficam explícitos e num
 * lugar só: a barra e seus painéis vencem o conteúdo e a sidebar, e continuam ABAIXO
 * dos modais (Chakra: overlay 1300 / modal 1400 / popover 1500 / tooltip 1800).
 */
export const topNavLayers = {
  /**
   * Menus e painéis abertos a partir da barra (conta, alertas, busca).
   *
   * A própria FAIXA não precisa de camada: desde a r2 ela é uma faixa dentro da área de
   * conteúdo, e não mais uma barra por cima da sidebar (que usa 99). O desenho anterior
   * exigia um valor para a barra; este não exige, e uma constante sem uso só convida a
   * alguém a confiar num z-index que não está aplicado em lugar nenhum.
   *
   * 110 fica acima do conteúdo e da sidebar, e continua ABAIXO do overlay do Chakra
   * (1300) — painel da barra nunca pode cobrir um modal.
   */
  panel: 110,
} as const;
